const standardEvents = [
  'PageView',
  'AddPaymentInfo',
  'AddToCart',
  'AddToWishlist',
  'CompleteRegistration',
  'Contact',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'InitiateCheckout',
  'Lead',
  'Purchase',
  'Schedule',
  'Search',
  'StartTrial',
  'SubmitApplication',
  'Subscribe',
  'ViewContent'
]

const event = (debug) => (name, data = {}) => {
  if (debug) {
    console.groupCollapsed(
      `[Vue Facebook Pixel] Track event "${name}"`)
    console.dir(`With data: ${data}`)
    console.groupEnd()
  }

  if (!standardEvents.includes(name)) {
    fbq('trackCustom', name, data)
  } else {
    fbq('track', name, data)
  }
}

function loadScript (scriptSrc) {
  if (window.fbq) return

  const fbq = (window.fbq = function () {
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments)
      : fbq.queue.push(arguments)
  })

  if (!window._fbq) {
    window._fbq = fbq
  }

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  const scriptNode = document.getElementsByTagName('script')[0]

  script.async = true
  script.src = scriptSrc
  scriptNode.parentNode.insertBefore(script, scriptNode)
}

function setFBPixel (Vue, options) {
  const { pixelIds, env, debug } = options

  if (env === 'production') {
    pixelIds.forEach((id) => {
      fbq('init', id)
    })
  }

  Vue.prototype.$fbq = { event: event(debug) }
}

export default function install (Vue, options) {
  loadScript(options.scriptSrc)
  setFBPixel(Vue, options)
}
